import { useState } from "react";
import "./DashboardV2.scss";
import { Button } from "components/v2/button/Button";

export default function DashboardV2() {
  const [activeTab, setActiveTab] = useState("new");
  
  return (
    <div className="dashboard-v2">
      {/* Main Content */}
      <main className="dashboard-main">
        {/* Left Column (Tasks) */}
        <section className="task-column">
          <h2>Tasks</h2>
          <p className="task-desc">These are your outstanding tasks. Complete them to keep moving forward.</p>

          <div className="task-tabs">
            <button
              className={`tab-btn ${activeTab === "new" ? "active" : ""}`}
              onClick={() => setActiveTab("new")}
            >
              New
            </button>
            <button
              className={`tab-btn ${activeTab === "complete" ? "active" : ""}`}
              onClick={() => setActiveTab("complete")}
            >
              Complete
            </button>
          </div>

          <div className="task-card">
            <strong>Additional Documents</strong>
            <p className="task-note">Upload any documents at any time</p>
          </div>
        </section>

        {/* Right Column (Upload) */}
        <section className="upload-column">
          <h3>W-2 Forms for 2024 – 2023</h3>
          <p className="upload-desc">
            Lorem ipsum dolor sit amet consectetur. Sed blandit nibh arcu sed sit.
          </p>

          <div className="assigned-to">
            👤 Assigned to: <strong>Emma Johnson</strong>
          </div>

          <div className="upload-box">
            <p><strong>Drag or drop files here</strong></p>
            <p>or</p>
            <p className="upload-hint">
              Supported files: .pdf, .doc, .jpg, .jpeg, .jpe <br />
              Max size: 32 MB
            </p>
          </div>

          <Button className="submit-btn">Submit</Button>
        </section>
      </main>
    </div>
  );
}
